<div class="navbar-header"
     data-cy="navigation-header"
>
  <mb-link [linkData]="{uid: cmsLinkType.CONTENT_LINK, url: '/'}"
           [isCxRoute]="true"
           [useSlot]="true"
           (clickEvent)="logoClick.emit($event)"
           styleClass="navbar-brand"
           dataCy="navigation-logo-link"
  >
    <img alt="Logo"
         class="logo"
         data-cy="navigation-logo-image"
         src="/assets/images/miltenyi-biotec-logo.svg"
         title="Logo"
    />
  </mb-link>
</div>